import { compose, defaultProps, withProps } from "recompact"
import { connect } from "react-redux"
import React from "react"
import { DEFAULT_DATE_FORMAT } from "src/containers/Calendar/constants"
import planModel from "src/models/plan"
import entityList from "src/hocs/entityList"
import EntityListEditor from "src/components/EntityListEditor"
import SmallLockIcon from "src/icons/smallLock.svg"
import moment from "moment-timezone"
import Constraints from "src/components/PlanConstraints"
import {
  PLAN_CREATE,
  PLAN_UPDATE,
  PLAN_DELETE,
  PLAN_CONSTRAINTS_UPDATE,
  PLAN_EVENT_TYPES_UPDATE,
  PLAN_REPORT_TEMPLATES_UPDATE,
  PLAN_RESOURCES_UPDATE,
} from "src/constants/knownPermissions"
import {
  PLANS_URL,
  PLANS_ID_MAIN_URL,
  PLANS_ID_RESOURCES_URL,
  PLANS_ID_CONSTRAINT_URL,
} from "src/constants/routeNames"
import { hasPermission } from "src/engine/modules/currentUser"
import entityApi from "src/hocs/entity"
import queryString from "query-string"
import MappedTags from "./components/MappedTags"
import PlanResourcesModal from "./Item/PlanResourcesModal"
import Item, { FORM_NAME } from "./Item"
import FilterForm from "./Filter"

const openPlan = ({
  history,
  plan: { id },
  match: {
    params: { date, scale },
  },
}) => () => {
  history.push(`${PLANS_URL}/${id}/calendar/${scale}/${date}/`)
}

const columns = () => [
  {
    accessor: `name`,
    Header: `Наименование плана`,
    sortable: true,
    maxWidth: 300,
  },
  {
    accessor: `planTypeName`,
    Header: `Тип`,
    sortable: true,
    maxWidth: 300,
  },
  {
    accessor: `locked`,
    Header: () => (
      <div>
        <SmallLockIcon size="small" color="#bfbfbf" />
        &nbsp;
      </div>
    ),
    sortable: true,
    width: 80,
    Cell: ({ original: { locked } }) => (
      <div>{locked && <SmallLockIcon size="small" color="#bfbfbf" />}</div>
    ),
  },
  {
    accessor: `startDateTime`,
    Header: `Начало`,
    sortable: true,
    maxWidth: 150,
    Cell: ({ original: { startDateTime: seconds } }) => (
      <div>{moment(seconds).format(DEFAULT_DATE_FORMAT)}</div>
    ),
  },
  {
    accessor: `endDateTime`,
    Header: `Окончание`,
    sortable: true,
    Cell: ({ original: { endDateTime: seconds } }) => (
      <div>{moment(seconds).format(DEFAULT_DATE_FORMAT)}</div>
    ),
  },
  {
    accessor: `tags`,
    Header: `Теги`,
    sortable: false,
    Cell: ({ original }) => (
      <div className="cells">
        <MappedTags tags={original.tags} />
      </div>
    ),
    resizable: false,
  },
]

const enhancer = compose(
  entityList({
    model: planModel,
    ITEM_FORM_NAME: FORM_NAME,
    baseUri: PLANS_URL,
    columns,
  }),
  withProps(
    props =>
      props.match.params.id !== `new` && {
        id: props.match.params.id || props.match.params.planId,
      },
  ),
  entityApi({
    to: `plan`,
    model: planModel,
    onCreate: ({ history, queryParams }) => ({ id }) => {
      history.push(
        `${PLANS_URL}/${id}/main?${queryString.stringify(queryParams)}`,
      )
    },
  }),
  defaultProps({
    EntityEditor: defaultProps({
      onCreate: openPlan,
    }),
    FilterEditor: FilterForm,
    tabConfig: {
      createTitle: `Создание плана`,
      editTitle: `Редактирование плана`,
      basicUrl: `/plans`,
      tabs: [
        {
          name: `Общая информация`,
          to: PLANS_ID_MAIN_URL,
          id: `main`,
          component: connect(state => ({
            disableEditMain: !hasPermission(PLAN_UPDATE)(state),
            disableEditEventTypes: !hasPermission(PLAN_EVENT_TYPES_UPDATE)(
              state,
            ),
            disableEditReportTemplates: !hasPermission(
              PLAN_REPORT_TEMPLATES_UPDATE,
            )(state),
          }))(Item),
        },
        {
          name: `Управление ресурсами`,
          to: PLANS_ID_RESOURCES_URL,
          id: `resources`,
          component: connect(state => ({
            disableEdit: !hasPermission(PLAN_RESOURCES_UPDATE)(state),
          }))(PlanResourcesModal),
        },
        {
          name: `Ограничения`,
          to: PLANS_ID_CONSTRAINT_URL,
          id: `constraint`,
          component: connect(state => ({
            disableEdit: !hasPermission(PLAN_CONSTRAINTS_UPDATE)(state),
          }))(Constraints),
        },
      ],
    },
  }),
  connect(state => ({
    disableCreate: !hasPermission(PLAN_CREATE)(state),
    disableEdit: !hasPermission(PLAN_UPDATE)(state),
    disableDelete: !hasPermission(PLAN_DELETE)(state),
  })),
  withProps(({ plan }) => ({ dataForTabs: { plan } })),
)

export default enhancer(EntityListEditor)
